<template>
  <div class="login">
    <div class="login-cointainer">
      <div class="photo" v-if="head_img">
        <van-image height="100%" :src="head_img" fit="cover" />
      </div>
    </div>
    <input
      class="hide_file"
      ref="leftFile"
      id="upload"
      type="file"
      @change="getFile($event)"
      accept="image/*"
    />
    <van-popup
      class="login_opt"
      :close-on-click-overlay="false"
      v-model="show"
      round
      position="bottom"
      :style="{ height: '20%' }"
    >
      <h4 class="login_opt_title">
        拍摄已完成
        <span style="color: #f41b5d; margin: 0 5px"></span>
      </h4>
      <div>
        <div class="login_opt_confirm login_opt_btn" @click="handleSub">
          <span>确认提交</span>
        </div>

        <div class="login_opt_cancel login_opt_btn" @click="clickFile">
          重新拍摄
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import CommonTitle from "@/components/CommonTitle/Index";
import NotFound from "@/components/Notfound";
import next from "@/assets/next.png";
import login_bg from "@/assets/login_bg.png";
import { Toast } from "vant";
import axios from "axios";
const baseUrl = process.env.NODE_ENV === "production" ? "/app" : "/api";
import { getCheckImg } from "@/api/attest";

export default {
  components: { CommonTitle, NotFound },
  data() {
    this.baseUrl = baseUrl;
    this.next = next;
    this.login_bg = login_bg;
    return {
      url: "",
      phone: "",
      type: 1,
      show: false,
      head_img: "",
      upload: false,
      image: "",
      img: "",
    };
  },
  methods: {
    // 点击触发input的点击事件
    clickFile() {
      this.$refs.leftFile.click();
    },
    // 获取选择的图片文件上传
    getFile(e) {
      this.show = false;
      let file = e.target.files[0];
      console.log(file);
      let param = new FormData(); //创建form对象
      param.append("file", file, file.name); //通过append向form对象添加数据
      // param.append("id", this.token);
      param.append("module", "module");
      console.log(file);
      let config = {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("gl_token"),
          "Content-Type": "multipart/form-data",
        },
      }; //添加请求头
      axios
        .post(`${this.baseUrl}/uploadFile`, param, config)
        .then((res) => {
          if (res.data.status == 0) {
            // this.head_img = res.data.data;
            // // this.upload = false;
            // this.show = true;
            console.log(res.data)
          } else if (res.data.status == 2) {
            this.$refs.leftFile.click();
            this.$toast(res.data.message);
          }
        });
    },
    handleSub() {
      const toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "提交成功，3秒后进行上传！",
      });

      let second = 3;
      const timer = setInterval(() => {
        second--;
        if (second) {
          toast.message = `提交成功，${second} 秒后进行上传！`;
        } else {
          this.ApplyCheckImg();
          clearInterval(timer);
          // 手动清除 Toast
          Toast.clear();
        }
      }, 1000);
    },
    ApplyCheckImg() {
      console.log("图片认证");
      getCheckImg({
        img: this.head_img,
        applyId: this.$route.query.aId,
        settingId: this.$route.query.sId,
      }).then((res) => {
        Toast.success(res.message);
        this.$router.push({ path: "/record", query: {} });
      });
    },
  },
  created() {},
  mounted() {
    this.$refs.leftFile.click();
  },
};
</script>
<style lang="less" scoped>
.login {
  width: 100%;
  height: 100%;
  .hide_file {
    display: none;
  }
  &-cointainer {
    .photo {
      position: fixed;
      width: 100%;
      height: 100%;
    }
  }
  &_opt {
    text-align: center;
    &_title {
      font-size: @m-font-size;
      padding: 20px 20px;
    }
    &_btn {
      width: 126px;
      height: 44px;
      line-height: 44px;
      font-size: @s-font-size;
      border-radius: 22px;
      display: inline-block;
    }
    &_confirm {
      background: @blue;
      color: @white;
    }
    &_cancel {
      border: 1px solid @grey;
      margin-left: 30px;
    }
  }
}
</style>
